import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import App from "./App.jsx";
// import "./index.css";
import "./styles/globals.css";
import { captureClaimCodeFromUrl } from "./utils/claimCode";

captureClaimCodeFromUrl();
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
